export { CacheService } from './src/cache.service';
export { CacheFactory } from './src/cache.factory';
export { CacheStrategy, CacheInjectionOptions } from './src/interfaces';
